import FakturPajak from "@/components/dasboard-fp/faktur_pajak/FakturPajak.vue";
import FakturPajakAdd from "@/components/dasboard-fp/faktur_pajak/FakturPajakAdd.vue";
import FakturPajakDetail from "@/components/dasboard-fp/faktur_pajak/FakturPajakDetail.vue";
import FakturPajakEdit from "@/components/dasboard-fp/faktur_pajak/FakturPajakEdit.vue";
import FakturPajakUpload from "@/components/dasboard-fp/faktur_pajak/FakturPajakUpload.vue";
import FakturPajakByCompany from "@/components/dasboard-fp/faktur_pajak/FakturPajakByCompany.vue";

let routesFakturPajak= [
    {
        path: '',
        meta: {
          title: "Faktur Pajak",
        },
        name: "FakturPajak",
        component: FakturPajak
      },
    
      {
        path: 'bycompany/:id',
        meta: {
          title: "Faktur Pajak",
        },
        name: "FakturPajakByCompany",
        component: FakturPajakByCompany
      },
      {
        path: 'add',
        meta: {
          title: "Faktur Pajak",
        },
        name: "FakturPajakAdd",
        component: FakturPajakAdd
      },
    
      {
        path: 'edit/:id',
        meta: {
          title: "Faktur Pajak",
        },
        name: "FakturPajakEdit",
        component: FakturPajakEdit
      },
    
      {
        path: 'detail/:id',
        meta: {
          title: "Faktur Pajak",
        },
        name: "FakturPajakDetail",
        component: FakturPajakDetail
      },
    
      {
        path: 'upload',
        meta: {
          title: "Faktur Pajak",
        },
        name: "FakturPajakUpload",
        component: FakturPajakUpload
      },
    
]

export default routesFakturPajak
  